import { apiGet, buildQuery } from "./http";

export interface ParcelDTO {
  inspireid: string;
  comune: string;
  foglio: string;
  particella: string;
  nat_ref: string;
  label: string | null;
  bbox: { minLat: number; maxLat: number; minLon: number; maxLon: number };
  polygon_latlon: number[][];
}

export interface CatastoStats {
  particelle: number;
  comuni: number;
}

export interface ByPointResponse {
  lat: number;
  lon: number;
  matches: ParcelDTO[];
  elapsed_ms: number;
}

export function catastoStats(): Promise<CatastoStats> {
  return apiGet<CatastoStats>("/api/catasto/stats");
}

export function catastoByRef(comune: string, foglio: string, particella: string): Promise<ParcelDTO> {
  return apiGet<ParcelDTO>(`/api/catasto/by-ref${buildQuery({ comune, foglio, particella })}`);
}

export function catastoByPoint(lat: number, lon: number): Promise<ByPointResponse> {
  return apiGet<ByPointResponse>(`/api/catasto/by-point${buildQuery({ lat, lon })}`);
}

export interface GeocodeHit {
  lat: number;
  lon: number;
  display_name: string;
  boundingbox?: [number, number, number, number];
  importance?: number;
  osm_type?: string;
  address?: {
    road?: string;
    houseNumber?: string;
    postcode?: string;
    city?: string;
    province?: string;
    provinceCode?: string;
    region?: string;
    country?: string;
  };
}

export interface ByAddressResponse {
  q: string;
  geocoded: GeocodeHit;
  matches: ParcelDTO[];
  elapsed_ms: number;
}

export function catastoByAddress(q: string): Promise<ByAddressResponse> {
  return apiGet<ByAddressResponse>(`/api/catasto/by-address${buildQuery({ q })}`);
}

export function reverseGeocode(lat: number, lon: number): Promise<GeocodeHit> {
  return apiGet<GeocodeHit>(`/api/catasto/reverse-geocode${buildQuery({ lat, lon })}`);
}

export function geocodeAddress(q: string, limit = 5): Promise<{ q: string; hits: GeocodeHit[] }> {
  return apiGet<{ q: string; hits: GeocodeHit[] }>(`/api/catasto/geocode${buildQuery({ q, limit })}`);
}
